export const API_BASE = import.meta.env.VITE_API_BASE;
export const API_LLM_BASE = import.meta.env.VITE_API_LLM_BASE;
export const API_GRAPH_BASE = import.meta.env.VITE_API_GRAPH_BASE;
export const ZBRAIN_BASE_URL = import.meta.env.VITE_ZBRAIN_BASE_URL;
export const STORAGE_BASE = import.meta.env.VITE_STORAGE_BASE;
export const ENVIRONMENT_TYPE = import.meta.env.VITE_ENVIRONMENT_TYPE;
export const ADMIN_LIST = import.meta.env.VITE_ADMIN_EMAIL;
export const REQUEST_VIEW_USERS = import.meta.env.VITE_REQUEST_VIEW_USERS;
export const SAS_TOKEN = import.meta.env.VITE_SAS_TOKEN;

export const COPILOT_APP_ID = '6856774964336a971d20a63e';
export const KEY_INFO_APP_ID = '681c9ebf762adb28041bf0ef';
export const ENVIRONMENT = import.meta.env.MODE;
export const RELATED_USE_CASES_ENABLED = import.meta.env.VITE_RELATED_USE_CASES_ENABLED;
